/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
export var VARIANT = Object.freeze({
  solid: 'solid',
  light: 'light',
  outlined: 'outlined'
}); // todo: dynamic identity map generation

export var KIND = {
  custom: 'custom',
  // semantic
  neutral: 'neutral',
  primary: 'primary',
  accent: 'accent',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative',
  // primitive
  black: 'black',
  blue: 'blue',
  green: 'green',
  red: 'red',
  yellow: 'yellow',
  orange: 'orange',
  purple: 'purple',
  brown: 'brown'
};